import { IpaDatasetFilter } from '../types'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export const generateDatasetFilters = (filters): IpaDatasetFilter[] => {
  const filterList: IpaDatasetFilter[] = []

  if (filters?.fleetId?.length > 0) {
    filterList.push({
      type: 'Fleet',
      value: filters.fleetId
    })
  }

  if (filters?.vehicleId?.length > 0) {
    filterList.push({
      type: 'Vehicle',
      value: filters.vehicleId
    })
  }

  if (filters?.names?.length > 0) {
    filterList.push({
      type: 'Collection',
      value: filters.names
    })
  }

  if (filters?.extensions?.length > 0) {
    filterList.push({
      type: 'Extension',
      value: filters.extensions
    })
  }

  if (filters?.startDate) {
    const startUtc = dayjs
      .utc(filters.startDate, 'YYYY/MM/DD HH:mm:ss')
      .toDate()
    filterList.push({ type: 'StartDate', value: startUtc })
  }

  if (filters?.endDate) {
    const endUtc = dayjs.utc(filters.endDate, 'YYYY/MM/DD HH:mm:ss').toDate()
    filterList.push({ type: 'EndDate', value: endUtc })
  }

  return filterList
}
